define('directives/tipMsg/tip-msg.directive',['app', 'mainCons'], function (app, mainCons) {
    app.directive('tipMsg', ['$q', '$rootScope', '$filter', 'modUserInfoService', '$timeout', 'auiDialog',
        'modBussService', 'UserInfo', 'remindToUpdateUserInfo', 'auiAppTransferService', 'auiAgreementHelper', '$state', 'OpenUp',
        function ($q, $rootScope, $filter, modUserInfoService, $timeout, auiDialog,
                  modBussService, UserInfo, remindToUpdateUserInfo, auiAppTransferService, auiAgreementHelper, $state, OpenUp) {
            return {
                restrict: "EA",
                scope: false,
                templateUrl: "../refactor/directives/tipMsg/tip-msg.template.html",
                link: function ($scope) {
                    //横幅里面不能弹窗
                    $scope.mainUserID = AUI.HDGWCall.getUserInfoValue('teamid');
                    $scope.today = new Date().getTime();
                    $scope.after2Month = new Date().getTime() + sysParamCfg.today2MonthTime;
                    $scope.after3Month = new Date().getTime() + (90 * 24 * 60 * 60 * 1000);
                    var isSignMerchant = false;
                    $scope.filterClosedMsg = function (msgList) {
                        var msgCacheRemovedList = window.sessionStorage.getItem("msgCache") && angular.fromJson(window.sessionStorage.getItem("msgCache"));
                        if (!msgCacheRemovedList) return msgList;
                        for (var index = msgList.length - 1; index >= 0; index--) {
                            for (var i = 0; i < msgCacheRemovedList.length; i++) {
                                if (angular.toJson(msgList[index]) == angular.toJson(msgCacheRemovedList[i])) {
                                    msgList.splice(index, 1);
                                    break;
                                }
                            }
                        }
                        return msgList;
                    }
                    $scope.setTipMsg = function setTipMsg(stateName) {
                        var defer = $q.defer();
                        $scope.firstmessTipSmrz = "";
                        $scope.secondmessTipSmrz = "";
                        var msgList = [];
                        $scope.agreeListNew = [];
                        if ($scope.agreeList) {
                            $scope.agreeListNew = angular.copy($scope.agreeList);
                        }
                        for (var i = 0; i < $scope.agreeListNew.length; i++) {
                            $scope.agreeListNew[i].type = 1; //type=1 协议签署提示 type=2 审核信息提示
                            $scope.agreeListNew[i].title = $scope.agreeListNew[i].agrName + " 已经更新"; //type=1 协议签署提示 type=2 审核信息提示
                            $scope.agreeListNew[i].text = "为保证您在华为开发者联盟的各项服务不受影响，请您确认最新版本的服务协议。"; //type=1 协议签署提示 type=2 审核信息提示
                            msgList.push($scope.agreeListNew[i]);
                        }
                        $scope.agreeList = angular.copy(msgList);
                        if ($rootScope.transferCount > 0) {
                            msgList.push({
                                title: "应用转移",
                                text: "您收到新的应用转移请求，请前往接收。",
                                type: 3
                            });
                        }
                        //1获取实名认证审核提示语(个人 企业) 2商户服务 3 付费服务list
                        UserInfo.promise().then(function (user) {
                            if (user) {
                                $scope.id = user.id;
                                //判断是不是主帐号登陆 $scope.mainUserID 不存在证明是主帐号
                                if (!$scope.mainUserID) {
                                    //判断是企业还是个人 userType = 2是企业
                                    if (user.userType == 2) {
                                        //企业证件已过期场景
                                        if ((user.corpBsLicExpDate && AUI.DateUtil.DateStr2UtcMills(user.corpBsLicExpDate) < $scope.today) || (user.orgCodeExpDate && AUI.DateUtil.DateStr2UtcMills(user.orgCodeExpDate) < $scope.today)) {
                                            msgList.push({
                                                title: "开发者证件已过期",
                                                text: "您的企业证件已过期，请及时更新您的证件，以免影响您在华为开发者联盟的业务运营。",
                                                type: 5,
                                                pageType: "mysetting.userInfo"
                                            });
                                            //企业证件即将到期
                                        } else if ((user.corpBsLicExpDate && AUI.DateUtil.DateStr2UtcMills(user.corpBsLicExpDate) < $scope.after3Month) || (user.orgCodeExpDate && AUI.DateUtil.DateStr2UtcMills(user.orgCodeExpDate) < $scope.after2Month)) {
                                            msgList.push({
                                                title: "开发者证件即将过期",
                                                text: "您的企业证件即将过期，请及时更新您的证件，以免影响您在华为开发者联盟的业务运营。",
                                                type: 5,
                                                pageType: "mysetting.userInfo"
                                            });
                                        }
                                        //企业法人身份证已过期
                                        if (user.legalManCtfExpDate && AUI.DateUtil.DateStr2UtcMills(user.legalManCtfExpDate) < $scope.today) {
                                            msgList.push({
                                                title: "开发者证件已过期",
                                                text: "您提供的身份证已过期，请及时更新您的证件，以免影响您在华为开发者联盟的业务运营。",
                                                type: 5,
                                                pageType: "mysetting.userInfo"
                                            });
                                        } else if (user.legalManCtfExpDate && AUI.DateUtil.DateStr2UtcMills(user.legalManCtfExpDate) < $scope.after3Month) {
                                            msgList.push({
                                                title: "开发者证件即将过期",
                                                text: "您提供的身份证即将过期，请及时更新您的证件，以免影响您在华为开发者联盟的业务运营。",
                                                type: 5,
                                                pageType: "mysetting.userInfo"
                                            });
                                        }
                                    } else if (user.userType == 1) {//个人
                                        if (user.ctfExpireDate && AUI.DateUtil.DateStr2UtcMills(user.ctfExpireDate) < $scope.today) {//身份证到期提醒
                                            msgList.push({
                                                title: "开发者证件已过期",
                                                text: "您的身份证已过期，请及时更新您的证件，以免影响您在华为开发者联盟的业务运营。",
                                                type: 5,
                                                pageType: "mysetting.userInfo"
                                            });
                                        } else if (user.ctfExpireDate && AUI.DateUtil.DateStr2UtcMills(user.ctfExpireDate) < $scope.after3Month) {//身份证即将到期
                                            msgList.push({
                                                title: "开发者证件即将过期",
                                                text: "您的身份证即将过期，请及时更新您的证件，以免影响您在华为开发者联盟的业务运营。",
                                                type: 5,
                                                pageType: "mysetting.userInfo"
                                            });
                                        }
                                    }
                                }
                                $scope.handleSpecificAgreement().then(function (specificRes) {
                                    for (var i = 0; i < specificRes.length; i++) {
                                        msgList.push(specificRes[i]);
                                    }
                                    $scope.setTipMsgSmrz(user).then(function (res) {
                                        for (var i = 0; i < res.length; i++) {
                                            if (!$scope.mainUserID) {
                                                msgList.push(res[i]);
                                            }
                                        }
                                        UserInfo.promise().then(function (latestUserInfo) {
                                            if (latestUserInfo) {
                                                modBussService.getBussinesInfoMsg(latestUserInfo).then(function (data) {
                                                    $scope.setTipMsgSh(data, stateName).then(function (ret) {
                                                        for (var i = 0; i < ret.length; i++) {
                                                            //TODO 判断是否有商户权限
                                                            msgList.push(ret[i]);
                                                        }
                                                        var smrezTipMsg = mainCons.modUserinfoConstant.autingNewSmrz;
                                                        if (latestUserInfo.verifyType == 3) {
                                                            smrezTipMsg = mainCons.modUserinfoConstant.autingNewCorpaSmrz;
                                                        }
                                                        //判断用户是否实名认证正在审核  在审核中 页头提示语展示
                                                        if (latestUserInfo.verifyRealState == 1 && !$scope.mainUserID) { //不包括变更实名认证审核中的状态  updateRealState = 1
                                                            var msgSmrzSh = {
                                                                title: "实名认证审核中",
                                                                text: smrezTipMsg,
                                                                type: 2,
                                                                pageType: "mysetting.userInfo"
                                                            };
                                                            msgList.push(msgSmrzSh);
                                                        }
                                                        defer.resolve(msgList);
                                                    }).catch(function () {
                                                        defer.resolve(msgList);
                                                    });
                                                });

                                            } else {
                                                defer.resolve(msgList);
                                            }
                                        }).catch(function () {
                                            defer.resolve(msgList);
                                        });
                                    });
                                })
                            } else {
                                defer.resolve();
                            }
                        }).catch(function () {
                            defer.resolve(msgList);
                        });
                        return defer.promise;
                    }
                    $scope.setTipMsgSmrz = function (user) {
                        var defer = $q.defer();
                        var msgSmrzList = [];
                        var msgObj = {
                            title: "提示",
                            text: "",
                            type: 2,
                            pageType: "mysetting.userInfo"
                        };
                        //个人和企业相同的判断逻辑
                        if (user.updateRealState == 3) {

                            if (user.approveOpinion != "102") {
                                $scope.firstmessTipSmrz = mainCons.modUserinfoConstant.nopassTip + user.approveOpinion;
                            } else {
                                $scope.firstmessTipSmrz = "";
                            }
                            if ($scope.firstmessTipSmrz != "") {
                                msgObj.title = "开发者信息审核未通过";
                                msgObj.text = $scope.firstmessTipSmrz;
                                msgSmrzList.push(angular.copy(msgObj));
                            }
                            defer.resolve(msgSmrzList);
                        } else if (user.updateRealState == 1 || user.isChangeRealName == 1 || user.verifyRealState == 1) {
                            modUserInfoService.getExtAttr('reAutoVerify').then(function (data) {
                                //打款认证的，如果是初次的是3 1  如果是应用市场AGC进来的 reAutoVerify == 1 然后就是可以到打款
                                if ((data && data == 1 && user.updateRealState == 1)) {
                                    msgObj.title = "实名认证审核中";
                                    msgObj.text = mainCons.modUserinfoConstant.autingNewCorpaSmrz;
                                    msgSmrzList.push(angular.copy(msgObj));
                                } else {
                                    $scope.firstmessTipSmrz = (user.isChangeRealName == 1 ? mainCons.modUserinfoConstant.autingByNameChangeTip : mainCons.modUserinfoConstant.autingTip);
                                    $scope.secondmessTipSmrz = mainCons.modUserinfoConstant.commonTip;
                                    if (user.isChangeRealName == 1) {
                                        msgObj.title = "更名申请审核中";
                                        $scope.secondmessTipSmrz = mainCons.modUserinfoConstant.commonTipGm;
                                    } else {
                                        if (user.updateRealState == 1) { //只有修改信息的时候提示本条  首次实名认证或者重新发我认证的时候不提示
                                            msgObj.title = "开发者信息审核中";
                                        } else {
                                            $scope.firstmessTipSmrz = "";
                                            $scope.secondmessTipSmrz = "";
                                        }
                                    }
                                    var msgSmrz = $scope.firstmessTipSmrz + $scope.secondmessTipSmrz;
                                    if (msgSmrz != "") {
                                        msgObj.text = msgSmrz;
                                        msgSmrzList.push(angular.copy(msgObj));
                                    }
                                }
                                defer.resolve(msgSmrzList);
                            })
                        } else {
                            defer.resolve(msgSmrzList);
                        }
                        return defer.promise;
                    }

                    $scope.setTipMsgSh = function (data, stateName) {
                        var defer = $q.defer();
                        var msgShList = [];
                        var msgObj = {
                            title: "提示",
                            text: "",
                            type: 2,
                            pageType: "mysetting.modBussnessInfo"
                        };
                        var developerInfo = data;
                        $scope.setTipMsgShAgree(data, stateName).then(function (ret) {
                            for (var i = 0; i < ret.length; i++) {
                                //TODO 判断是否有商户权限
                                msgShList.push(ret[i]);
                            }
                            if (data.isChangeRealName == 0) { //没有更名  或者 更名被驳回
                                if (developerInfo.commerceCertifyStatus == 3) { //商户被驳回 但不是更名流程造成的
                                    if ((data.bankInfoCN && data.bankInfoCN.verifyBankState != 3 && data.bankInfoCN.updateBankState != 3) || (data.bankInfoEN && data.bankInfoEN.verifyBankState != 3 && data.bankInfoEN.updateBankState != 3)) {
                                        modBussService.getNotifyMessage(function (data) {
                                            if (data) {
                                                msgObj.title = "商户资料审核未通过";
                                                msgObj.text = mainCons.modUserinfoConstant.noBankInfopassTip + data;
                                                msgShList.push(angular.copy(msgObj));
                                            }
                                            defer.resolve(msgShList);
                                        });
                                    } else if ((data.bankInfoCN && data.bankInfoCN.verifyBankDesc != "101") || (data.bankInfoEN)) {
                                        msgObj.title = "商户资料审核未通过";
                                        msgObj.text = mainCons.modUserinfoConstant.noBankInfopassTipNew;
                                        msgShList.push(angular.copy(msgObj));
                                        defer.resolve(msgShList);
                                    } else {
                                        defer.resolve(msgShList);
                                    }
                                } else {
                                    if((data.bankInfoEN && data.bankInfoEN.verifyBankState == 2)){
                                        OpenUp.getMerchantTaxInfo({
                                            req: {}
                                        }).then(function (taxInfo) {
                                            if(taxInfo.merchantTaxInfo && !taxInfo.merchantTaxInfo.registerEnAddress){
                                                msgObj.title = "英文税务注册地址";
                                                msgObj.text = "【系统消息】您的商户服务（跨境收款账户）英文税务注册地址待补充，为避免影响结算付款，请尽快补充相关信息。";
                                                msgShList.push(angular.copy(msgObj));
                                                defer.resolve(msgShList);
                                            }else{
                                                defer.resolve(msgShList);
                                            }
                                        });
                                    }else{
                                        defer.resolve(msgShList);
                                    }
                                }
                            } else {
                                defer.resolve(msgShList);
                            }
                        });
                        return defer.promise;
                    }
                    $scope.setTipMsgShAgree = function (data, stateName) {
                        var defer = $q.defer();
                        var msgShAgreeList = [];
                        if (((data.bankInfoCN && data.bankInfoCN.verifyBankState == 2)
                            || (data.bankInfoEN && data.bankInfoEN.verifyBankState == 2)) && stateName == 'mysetting.modBussnessInfo' && (!$scope.mainUserID || $scope.isLegal)) {
                            getIsSignAgreement().then(function (data) {
                                if (!data) {
                                    msgObj = {
                                        title: "华为开发者商户服务协议",
                                        text: "您已开通商户服务。如果您与华为合作提供付费产品或资源，您必须签署华为开发者商户服务协议。",
                                        type: 4
                                    };
                                    msgShAgreeList.push(angular.copy(msgObj));
                                }
                                defer.resolve(msgShAgreeList);
                            });
                        } else {
                            defer.resolve(msgShAgreeList);
                        }
                        return defer.promise;

                    };

                    //展示提示语列表
                    $scope.swiper = null;

                    //處理单签协议
                    $scope.handleSpecificAgreement = function () {
                        var defer = $q.defer();
                        var msgSpecificAgreement = [];
                        if (sessionStorage.getItem($scope.id + 'SpecificAgreement') == 'cancel') {
                            OpenUp.getTobeSignedSpecificAgreement({req: {portalType: 1}}).then(function (resp) {
                                if (resp && resp.tobeSignedSpecificAgreement && resp.tobeSignedSpecificAgreement.length > 0) {
                                    for (var i = 0; i < resp.tobeSignedSpecificAgreement.length; i++) {
                                        var tobeSignedSpecificAgreement = {};
                                        tobeSignedSpecificAgreement.type = 6; //type=6 单签协议
                                        tobeSignedSpecificAgreement.documentVersion = resp.tobeSignedSpecificAgreement[i].documentVersion;
                                        tobeSignedSpecificAgreement.title = resp.tobeSignedSpecificAgreement[i].agreementName + " 待签署"; //type=6 单签协议
                                        tobeSignedSpecificAgreement.text = ""; //type=6 单签协议
                                        msgSpecificAgreement.push(tobeSignedSpecificAgreement);
                                    }
                                }
                                defer.resolve(msgSpecificAgreement);
                            })
                        } else {
                            defer.resolve(msgSpecificAgreement);
                        }
                        return defer.promise;
                    }


                    $scope.displayAgreeListNew = function (msglist) {
                        $timeout(function () {
                            var oUl = document.getElementsByClassName("sample-grid")[0];
                            if (!$scope.swiper && oUl) {
                                $scope.swiper = new UCD.Swiper('.userguideTOP', {
                                    slideSelector: '.sample-grid',
                                    isNeedPointer: true,
                                    loop: true,
                                    autoPlay: true,
                                    interval: 5000,
                                    onChanged: function (index) {
                                        $scope.$apply($scope.clickPageNew());
                                    }
                                });
                                if (msglist.length > 0) {
                                    $('.userguideTOP').data('Sliding') || $scope.swiper;
                                }
                            }

                        }, 200);
                    }

                    $scope.closeTip = function (msg) {
                        var index = $scope.msgList.indexOf(msg);
                        var cacheList = window.sessionStorage.getItem("msgCache") ? angular.fromJson(window.sessionStorage.getItem("msgCache")) : [];
                        cacheList.push(msg);
                        window.sessionStorage.setItem("msgCache", angular.toJson(cacheList));
                        if (index > -1) {
                            $scope.msgList.splice(index, 1);
                            $scope.swiper = null;
                            $scope.displayAgreeListNew($scope.msgList);
                        }
                    }

                    $scope.acceptTransferTip = function () {
                        auiAppTransferService.appTransferService();
                    }
                    $scope.checkAndSignAgreement = function (msg) {
                        // 查询是否签署过最新支付协议
                        auiAgreementHelper.checkAgreement('tenants', function () {
                        }).then(function (data) {
                            var isSigned = data.signed; //是否已经签署最新协议
                            //如果已经签署去一条横幅
                            if (isSigned) {
                                $scope.closeTip(msg);
                                //监听提交事件
                                $scope.$emit("stateChangedEventToBuss", true);
                            }
                        });
                    }

                    //判断是否签署过商户协议
                    function getIsSignAgreement() {
                        var defer = $q.defer();
                        if (isSignMerchant) {
                            defer.resolve(true);
                        } else {
                            auiAgreementHelper.queryAgreements(['1003']).then(function (signInfo) {
                                if (signInfo && signInfo.signInfoList && signInfo.signInfoList.length > 0) {
                                    var signedText = signInfo.signInfoList[0];
                                    if (signedText.signStatus == 1 || signedText.signStatus == 2) {// 签署状态。1：已签署最新版本；2：已签署非最新版本；3：未签署；
                                        isSignMerchant = true;
                                        defer.resolve(true);
                                    } else {
                                        defer.resolve(false);
                                    }
                                } else {
                                    defer.resolve(true);
                                }
                            });
                        }
                        return defer.promise;
                    }

                    $scope.checkAndSignSpecificAgreement = function (msg) {
                        //已经弹窗过了也不弹了
                        OpenUp.getTobeSignedSpecificAgreement({req: {portalType: 1}}).then(function (resp) {
                            if (resp && resp.tobeSignedSpecificAgreement && resp.tobeSignedSpecificAgreement.length > 0) {
                                var tobeSignedSpecificAgreement = [];
                                resp.tobeSignedSpecificAgreement.forEach(function (agreement) {
                                    if (msg.documentVersion == agreement.documentVersion) {
                                        tobeSignedSpecificAgreement.push(agreement);
                                    }
                                })
                                auiAgreementHelper.specificAgreementDialogPDFMulti(tobeSignedSpecificAgreement).then(function (flag) {
                                    if (flag == 'signed') {
                                        $scope.closeTip(msg);
                                        if (resp.tobeSignedSpecificAgreement.length == 1) {
                                            sessionStorage.removeItem($scope.id + 'SpecificAgreement');
                                        }
                                    }
                                });
                            } else {
                                $scope.closeTip(msg);
                                sessionStorage.removeItem($scope.id + 'SpecificAgreement');
                            }
                        })
                    }


                }
            }
        }])
})
;
